module.exports = require('../internals/path');